import { IonPage,IonContent,IonRow,IonCol,IonImg } from '@ionic/react';
import  { FC } from 'react';
import { translation } from '../../models/translation';


const TransactionSuccess:FC = () => {

    const siteText = translation();

    return(
        <IonPage className='pageContent'>
            <IonContent>
                <IonRow className='ion-text-center sw_sp_lg'>
                    <IonCol offsetSm='2' sizeSm='8'>
                    < IonImg className='home_logo sw_mb_sm' src={`${process.env.PUBLIC_URL}/assets/swissdonations_logo_01.png`}></IonImg>
                        <h1 className='h2'>{siteText.transactionConfirmationSuccessTitle}</h1>
                        <p>{siteText.transactionConfirmationSuccessBody}</p>
                    </IonCol>
                </IonRow>
            </IonContent>
        </IonPage>
    )
}

export default TransactionSuccess;